import './NewTeamAddPagesButton.pcss';
import React from 'react';
import { compose } from 'recompose';
import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { PrimaryButton } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { StoreState } from '@mm/state/store-interfaces';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import modalActions from '@mm/state/modules/modalsState/actions';
import connectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { EnhancedPlan } from '@mm/state/interfaces/subscription';
import { PlusOutlined } from '@ant-design/icons';

type OuterProps = {
  totalPages: number;
  teamSubscription: SubscriptionModel;
  searchInput: string;
  setSearchInput: (searchInput: string) => void;
  teamPlan: EnhancedPlan;
};

type InnerProps = ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const NewTeamAddPagesButton = (props: Props) => {
  const {
    openAddMorePagesTeamModal,
    openSelectTeamPagesModal,
    teamSubscription,
    totalPages,
    retrieveBasicListByCompany,
    setSearchInput,
    searchInput,
    teamPlan,
  } = props;
  const company = useSelector((state: StoreState) =>
    activeCompanySelector(state),
  );
  const metPagesLimit = teamSubscription.pagesLimit
    ? totalPages >= teamSubscription.pagesLimit
    : true;

  const onClickAddMore = () => {
    if (searchInput && company) {
      retrieveBasicListByCompany(company.id);
      setSearchInput('');
    }

    openSelectTeamPagesModal(teamSubscription);
  };

  if (metPagesLimit) {
    if (teamSubscription.expiresAt) {
      return null;
    }

    return (
      <PrimaryButton
        className="new-team-add-pages-button"
        color="transparent-no-shadow"
        onClick={() => openAddMorePagesTeamModal(teamSubscription, teamPlan, 1)}
      >
        <PlusOutlined />
        Buy Pages
      </PrimaryButton>
    );
  }

  return (
    <PrimaryButton
      className="new-team-add-pages-button"
      color="transparent-no-shadow"
      onClick={onClickAddMore}
    >
      <PlusOutlined />
      Add Pages
    </PrimaryButton>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  openAddMorePagesTeamModal: (
    subscription: SubscriptionModel,
    plan: EnhancedPlan,
    pagesCount: number,
  ) =>
    dispatch(
      modalActions.openAddMorePagesTeamModal({
        subscription,
        plan,
        pagesCount,
      }),
    ),
  openSelectTeamPagesModal: (subscription: SubscriptionModel) =>
    dispatch(modalActions.openSelectTeamPagesModal({ subscription })),
  retrieveBasicListByCompany: (companyId: number) =>
    dispatch(
      connectedPageCRUDActions.retrieveBasicListByCompany(
        companyId,
        { withFacebookErrors: true, withSubscription: true },
        true,
      ),
    ),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(NewTeamAddPagesButton);
